import { Component, Input, OnInit } from '@angular/core';
import { RewardsWalletItem } from '@fgb/core';

@Component({
  selector: 'fgb-wallet-page',
  templateUrl: './wallet-page.component.html',
  styleUrls: ['./wallet-page.component.scss'],
})
export class WalletPageComponent implements OnInit {
  @Input() walletItems: RewardsWalletItem[];

  constructor() {}

  async ngOnInit() {}
}
